<div class="callback-container">
  <div class="callback-content">
    @if (isProcessing()) {
      <p>Processing callback...</p>
    }
    
    @if (error()) {
      <div class="error">
        <p>Error: {{ error() }}</p>
      </div>
    }
  </div>
</div>

